export default __webpack_public_path__ + "static/media/VYRO.563fabba.svg";